import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { JobData, OfferStatus } from '@core/tellent-assistant-types';
import { IconContainerComponent } from '@core/user-interface-legacy';

import { ListCardComponent } from '../../list-card/list-card.component';

const STATUS_LABEL: Record<OfferStatus, string> = {
  draft: 'Draft',
  published: 'Open',
  internal: 'Internal',
  closed: 'Closed',
  archived: 'Archived',
};

@Component({
  selector: 'rt-list-item-job',
  imports: [ListCardComponent, IconContainerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-job.component.html',
  styleUrl: './list-item-job.component.less',
})
export class ListItemJobComponent {
  protected readonly statusLabel = computed(() => STATUS_LABEL[this.data().status]);

  public readonly data = input.required<JobData>();
}
